var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessOfferAlcohol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,8h12c1.2,0 2.1,1 2,2.2l-0.7,8.3c-0.3,3.5 -2.4,6.5 -5.3,7.9V36h5v4H17v-4h5V26.4c-2.9,-1.4 -5,-4.4 -5.3,-7.9L16,10.2C15.9,9 16.8,8 18,8z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7,12h10.6l-0.4,5.1c-0.2,2.8 -2.6,4.9 -5.3,4.9c-2.8,0 -5.1,-2.1 -5.3,-4.9L18.7,12z",
    fill: "#7C1CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,12m-1.6,0a1.6,1.6 0,1 0,3.2 0a1.6,1.6 0,1 0,-3.2 0",
    fill: "#00D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessOfferAlcohol);
export default __webpack_public_path__ + "static/media/p4r_business_offer_alcohol.f0fbcc55309a1f314dba9488c515b7b5.svg";
export { ForwardRef as ReactComponent };